import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { map, filter, concat, pull, uniqueId } from 'lodash-es';
import { useMemo, useCallback } from 'react';
export function CheckboxesField(props) {
    const componentId = useMemo(() => uniqueId('checkboxes-field'), []);
    const { value, label, options, onChange } = props;
    const values = useMemo(() => filter(value.split(','), value => value !== ''), [value]);
    const handleChange = useCallback((event) => {
        const value = event.target.value;
        const newValues = values.includes(value) ? pull(values, value) : concat(values, value);
        onChange(newValues.join(','));
    }, [onChange, values]);
    return (_jsxs("div", { className: "checkboxes-field", children: [_jsx("legend", { children: label }), _jsx("div", { className: "checkboxes-field-inputs", children: map(options, (option, index) => (_jsx("div", { className: "checkboxes-field-checkbox", children: _jsxs("label", { htmlFor: componentId + index, children: [_jsx("input", { id: componentId + index, type: "checkbox", value: option.value, checked: values.includes(option.value), onChange: handleChange }), option.label] }) }, index))) })] }));
}
